/**
 * Scrollspy.
 *
 * @see https://github.com/shoelace-style/shoelace/blob/next/docs/assets/scripts/docs.js
 * @description Scrollspy for the documentation site.
 * @author Shoelace
 */
const defaultOptions = {
	contentBodyClass: 'main-content',
	selectedItemEventName: 'selected-item-updated',
	rootMargin: '-60% 0% -40% 0%',
}
export class Scrollspy {
	constructor(el) {
		this.beforeSetup();
		this.el = el;
		this.slug = el.dataset.scrollspy;

		if (el.dataset.scrollspyOptions) {
			this.options = Object.assign({}, defaultOptions, JSON.parse(el.dataset.scrollspyOptions));
		} else {
			this.options = Object.assign({}, defaultOptions);
		}

		this.afterSetup();

		this.links = [];
		this.linkTargets = null;
		this.visibleTargets = null;
		this.observer = null;
		this.mobileSelect = null;

		this.beforeInit();
		this.init();
		this.afterInit();
	}

	getLinks() {
		return this.links = [...this.el.querySelectorAll('a')];
	}

	handleIntersect(entries) {
		entries.forEach(entry => {
			// Remember which targets are visible
			if (entry.isIntersecting) {
				this.visibleTargets.add(entry.target);
			} else {
				this.visibleTargets.delete(entry.target);
			}
		});

		this.updateActiveLinks();
	}

	updateActiveLinks() {
	  	// Find the first visible target and activate the respective link
		this.links.find(link => {
			const target = this.linkTargets.get(link);
			this.el?.dispatchEvent(new CustomEvent(this.options.selectedItemEventName, { detail: link }, { bubbles: true }));

			if (target && this.visibleTargets.has(target)) {
				this.links.forEach(el => el.dataset.scrollspySelected = el === link);
				history.pushState(undefined, undefined, link.hash);
				if (this.mobileSelect) {
					this.mobileSelect.value = link.hash;
				}
				return true;
			}

			return false;
		});
	}

	// Observe link targets
	observeLinks() {
		this.links.forEach(link => {
			const hash = link.hash.slice(1);
			const target = hash ? document.querySelector(`.${this.options.contentBodyClass} #${hash}`) : null;

			if (target) {
				this.linkTargets.set(link, target);
				this.observer.observe(target);
			}
		});
	}

	buildObserver() {
		this.observer = new IntersectionObserver(this.handleIntersect.bind(this), { rootMargin: this.options.rootMargin });
	}

	getOffset() {
		const offset = window?.observers?.['stickyOffset']?.height ?? 0;
		return offset > 0 ? offset + 30 : 0;
	}

	buildMobileSelect() {
		this.mobileSelect = document.querySelector(`[data-scrollspy-select="${this.slug}"]`);
		if (!this.mobileSelect) { return }
		this.mobileSelect.addEventListener('change', () => {
			const hash = this.mobileSelect.value;
			if (hash) {
				const target = document.querySelector(hash);
				if (target) {
					this.el?.dispatchEvent(new CustomEvent(this.options.selectedItemEventName, { detail: target }, { bubbles: true }));
					window.scroll({ top: target.offsetTop - this.getOffset(), behavior: 'smooth' });
				}
			}
		});
	}

	init() {
		this.linkTargets = new WeakMap();
		this.visibleTargets = new WeakSet();
		this.getLinks();
		this.buildObserver();
		this.buildMobileSelect();
		this.updateActiveLinks();
		this.observeLinks();
	}

	beforeSetup() {}
	afterSetup() {}
	beforeInit() {}
	afterInit() {}
}
